"use strict";
import RecruitApiClient from "../../RecruitApiClient";
class Api {
  constructor() {
    this.refineScreening = (id, conditions) => RecruitApiClient.post(`/api/v4/candidate_sourcing/searches/${id}/refine_screening`, { conditions });
    this.createCandidatePool = (title) => RecruitApiClient.post(`/api/v4/candidate_sourcing/candidate_pools`, { title });
    this.addCandidatesToPools = (candidateGroupIds, poolIds) => RecruitApiClient.post(`/api/v4/candidate_sourcing/candidate_pools/add_candidates`, { candidate_group_ids: candidateGroupIds, pool_ids: poolIds });
    this.getCandidatePools = () => RecruitApiClient.get(`/api/v4/candidate_sourcing/candidate_pools`);
    this.getEmailTemplates = () => RecruitApiClient.get(`/api/v4/searches/email_templates?group_templates=true`);
    this.sendEmails = (data) => RecruitApiClient.post(`/api/v4/searches/bulk_email`, data);
    this.getEmailTemplateDetails = (id) => RecruitApiClient.get(`/api/v4/searches/email_templates/${id}`);
    this.getSearchingCandidates = (id, page, limit) => RecruitApiClient.get(`/api/v4/candidate_sourcing/searches/${id}/search_candidates`, { page, limit });
    this.revealContacts = (searchId, groupId) => RecruitApiClient.post(`/api/v4/candidate_sourcing/searches/${searchId}/candidate_groups/${groupId}/reveal_contacts`);
  }
}
export default new Api();
